import { create } from 'zustand'
import type { Rol } from '@rumbo/form'

export interface UsuarioSesion {
  id: string
  email: string
  nombre: string
  rol: Rol
  estados: string[]
  instituciones: string[]
  debeCambiarClave: boolean
  mfaActivo: boolean
  requiereConfigurarMfa: boolean
}

interface RespuestaSesion {
  accessToken: string
  expiraEnSeg: number
  usuario: UsuarioSesion
  requiereConfigurarMfa?: boolean
}

interface EstadoAuth {
  accessToken: string | null
  usuario: UsuarioSesion | null
  cargando: boolean
  establecerSesion: (r: RespuestaSesion) => void
  cerrarSesion: () => void
}

// El access token vive solo en memoria (nunca en localStorage: XSS lo robaría).
// La sesión persiste entre recargas gracias al refresh token en cookie HttpOnly.
export const useAuth = create<EstadoAuth>((set) => ({
  accessToken: null,
  usuario: null,
  cargando: true,
  establecerSesion: (r) =>
    set({
      accessToken: r.accessToken,
      usuario: { ...r.usuario, requiereConfigurarMfa: r.requiereConfigurarMfa ?? r.usuario.requiereConfigurarMfa },
      cargando: false,
    }),
  cerrarSesion: () => set({ accessToken: null, usuario: null, cargando: false }),
}))
